import { create } from 'zustand';

interface TimeStuckState {
  // milliseconds
  timeStuck: number;
  setTimeStuck: (timeStuck: number) => void;
  incrementTimeStuck: (delta: number) => void;
}

export const timeStuckStore = create<TimeStuckState>(set => ({
  timeStuck: 0,
  setTimeStuck: (timeStuck: number) => set({ timeStuck }),
  incrementTimeStuck: (delta: number) => {
    const timeStuck = timeStuckStore.getState().timeStuck + delta;

    set({ timeStuck });
  },
}));

export const getTimeStuck = (): number => timeStuckStore.getState().timeStuck;
